export default {
  helpText: 'Wybierz i posortuj kolumny, które chcesz wyświetlać w tabeli przeglądu zamówień. To ustawienie jest stosowane globalnie dla wszystkich użytkowników.',
  selectedColumns: 'Wybrane kolumny',
  nonSelectedColumns: 'Dostępne kolumny',
};
